// const routes = [
//     {
//         path: '/videoMonitoring',
//         name: 'dhVideoMonitor',
//         component: () => import('./main'),
//         redirect: "/videoMonitoring/index",
//         meta: {
//             requireAuth: true,
//         },
//         children: [
//             {
//                 path: 'index',
//                 name: 'dhVideoMonitorIndex',
//                 component: () => import('./view/index'),
//                 meta: {
//                     requireAuth: true,
//                     routerAlive: false
//                 },
//             },
//         ],
//     },
// ]

// export default routes

const routes = [
    {
        path: '/videoMonitoring',
        name: 'realTimeVideo',
        component: () => import('./view/index.vue'),
        meta: {
            requireAuth: true,
            routerAlive: false
        }
    }
]

export default routes